import React from 'react';
import { ChevronLeft } from 'lucide-react';

// Shared with every page that needs a "back" affordance. Previously each of
// the 4 door hub pages (and App.jsx) re-declared an identical local copy.
export const BackButton = ({ goBack, setPage, label = 'Back' }) => (
  <button
    onClick={() => (goBack ? goBack() : setPage && setPage('home'))}
    className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 font-medium"
  >
    <ChevronLeft className="w-5 h-5" />{label}
  </button>
);

export default BackButton;
